import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import { RouterName } from "@/types";
import { ref, onBeforeUnmount } from "vue";
import DOMPurify from "dompurify";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "SearchInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String,
    default: "search",
  },
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "노선 및 정류장을 검색하세요",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: "",
  },
  emphasis: {
    type: Boolean,
    default: false,
  },
  fixed: {
    type: Boolean,
    default: false,
  },
  locationSearch: {
    type: Boolean,
    default: false,
  },
  hideClearBtn: {
    type: Boolean,
    default: false,
  },
  delayMilliSeconds: {
    type: Number,
    default: 300,
  },
  isSearchIconRight: {
    type: Boolean,
    default: false,
  },
  showSearchButton: {
    type: Boolean,
    default: false,
  },
  searchButtonText: {
    type: String,
    default: "검색",
  },
  searchButtonDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:value", "onFocused", "onBlurred", "onInput", "onEnter", "clearText", "onClickSearchInput", "onClickSearchButton"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const searchInputRef = ref<HTMLInputElement>();
const focusingInputField = ref<HTMLInputElement>();

const isFocused = ref(false);

const focusInputField = () => {
  searchInputRef.value?.focus();
};

const onFocused = (event: Event) => {
  if (props.readonly) {
    return;
  }
  focusingInputField.value = event.target as HTMLInputElement;
  isFocused.value = true;
  emit("onFocused");
};

const onBlurred = () => {
  focusingInputField.value = undefined;
  isFocused.value = false;
  emit("onBlurred");
};

let timeout: ReturnType<typeof setTimeout>;
const onInput = (event: Event) => {
  const inputElement = event.target as HTMLInputElement;
  const sanitizedValue = DOMPurify.sanitize(inputElement.value);
  inputElement.value = sanitizedValue;

  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    emit("update:value", sanitizedValue);
    emit("onInput");
  }, props.delayMilliSeconds);
};

const onChange = (event: Event) => {
  const inputElement = event.target as HTMLInputElement;
  emit("update:value", inputElement.value);
};

const emitOnEnter = () => {
  searchInputRef.value?.blur();
  emit("onEnter");
};

const emitOnClickSearchButton = () => {
  emit("onClickSearchButton");
};

const clearText = () => {
  const blank = "";
  emit("update:value", blank);
  emit("clearText");
  focusInputField();
};

const goToMapOfNearbyBusStops = () => {
  router.push({ name: RouterName.MapOfNearbyBusStops });
};

onBeforeUnmount(() => {
  clearTimeout(timeout);
});

__expose({ searchInputRef, focusInputField });

const __returned__ = { props, emit, searchInputRef, focusingInputField, isFocused, focusInputField, onFocused, onBlurred, get timeout() { return timeout }, set timeout(v) { timeout = v }, onInput, onChange, emitOnEnter, emitOnClickSearchButton, clearText, goToMapOfNearbyBusStops, get RouterName() { return RouterName }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})